export default 'M16 12a1 1 0 0 0-1-1H9a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1m7-6H1V4a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3zm-4 17H5a3 3 0 0 1-3-3V8h20v12a3 3 0 0 1-3 3';